@if (!isUnderMaintenance) {
  @if (networkConnection === 'SLOW') {
    <div class="text-dark bg-warning text-center fs-14 py-1 d-flex align-items-center justify-content-center gap-2 sticky-top">
      <iconify [name]="'iconoir:wifi'" />
      Slow Network Connection
    </div>
  }
  @if (networkConnection === 'OFFLINE') {
    <div class="text-white bg-danger text-center fs-14 py-1 d-flex align-items-center justify-content-center gap-2 sticky-top">
      <iconify [name]="'iconoir:wifi-xmark'" />
      No Network Connection (offline)
    </div>
  }
} @else {
  <div class="text-black bg-info text-center fs-14 py-1 d-flex align-items-center justify-content-center gap-2 sticky-top">
    <iconify [name]="'iconoir:wifi-xmark'" />
    We are currently undergoing maintenance / deployment. Please try again later.
  </div>
}
